export default "__VITE_ASSET__Xk0tNt2q__"